export default __webpack_public_path__ + "static/media/resolutionError.2af80a32.svg";